import React, { FC, useEffect, useState } from 'react';
import { BackTop, Col, Drawer, Layout, Row, Typography } from 'antd';
import { IProps } from 'src/types/layout.types';
import styles from './main.module.less';
import Menu from 'src/components/dashboard/menu/menu';
import PropCapHeader from '../header/header';
import { CloseOutlined, DoubleLeftOutlined, MenuOutlined } from '@ant-design/icons';
import { t } from 'i18next';
import { i18nKey } from 'src/locales/i18n';
import TitleBox from 'src/components/title-box/title-box';
import { IOnboardingStore } from 'src/store/user/onboarding.store';
import useStore from 'src/hooks/useStore';
import { ONBOARDING_STATUSES, RESET_TIMEOUT_MODAL_EXPIRED_TIME_SD } from 'src/constants';
import { useLocation } from 'react-router-dom';
import { PAGE_ROUTE, disallowBackRouteList } from 'src/constants/route';
import { observer } from 'mobx-react-lite';
import { useShowResetTimeoutConfirmation } from 'src/hooks/useShowResetTimoutConfirmation';

const { Header, Content, Footer } = Layout;

const MainLayout: FC<IProps> = ({ children, removeMenu, fullWidth }: IProps) => {
	const [isOpenDrawer, setIsOpenDrawer] = useState(false);
	const onboardingStore: IOnboardingStore = useStore('onboardingStore');
	const location = useLocation();
	const contextHolder = useShowResetTimeoutConfirmation(RESET_TIMEOUT_MODAL_EXPIRED_TIME_SD);

	const onCloseDrawer = () => {
		setIsOpenDrawer(false);
	};

	let colSpan = [6, 16];
	if (removeMenu) {
		colSpan = [0, 24];
	}
	const onBackToTopClicked = () => {
		const anchor = document.getElementById('headerAnchor');
		anchor && anchor.scrollIntoView({ behavior: 'smooth' });
	};

	useEffect(() => {
		if (disallowBackRouteList.includes(location.pathname as PAGE_ROUTE)) {
			window.history.pushState(null, document.title, window.location.href);
			window.onpopstate = function () {
				history.go(1);
			};
		}
	}, [location]);

	return (
		<>
			<Layout>
				<Header className={styles.mainLayoutHeader} id="headerAnchor">
					<PropCapHeader
						showHome
						showContract
						showMortgage={
							onboardingStore.funderOnboardingRequest &&
							[ONBOARDING_STATUSES.Approved, ONBOARDING_STATUSES.SignedFSA].includes(
								Number(onboardingStore.funderOnboardingRequest.status)
							)
						}
					/>
				</Header>

				<Drawer
					placement="left"
					closable={false}
					open={isOpenDrawer}
					onClose={onCloseDrawer}
					key="left"
					title={
						<div
							style={{
								width: '100%',
								textAlign: 'right'
							}}>
							<CloseOutlined onClick={onCloseDrawer} />
						</div>
					}>
					<Menu
						onItemClick={() => {
							setIsOpenDrawer(false);
						}}
					/>
				</Drawer>

				<Content className={fullWidth ? '' : styles.mainLayoutContent}>
					{!removeMenu && (
						<Row>
							<Col xs={24} sm={24} md={24} lg={0}>
								<TitleBox
									style={{
										borderRadius: '0px'
									}}>
									<Row>
										<Col span={22}>{t(i18nKey.dashboard.menu.home)}</Col>
										<Col span={2}>
											<MenuOutlined onClick={() => setIsOpenDrawer(!isOpenDrawer)} />
										</Col>
									</Row>
								</TitleBox>
							</Col>
						</Row>
					)}

					<Row gutter={[8, 8]}>
						{!removeMenu && (
							<Col lg={colSpan[0]} xs={0} sm={0} md={0}>
								<Menu />
							</Col>
						)}
						<Col lg={colSpan[1]} xs={24} sm={24} md={24}>
							{children}
						</Col>
					</Row>

					{contextHolder}
				</Content>
				<Footer className={styles.mainLayoutFooter}>
					<Typography.Text>Copyright © PropCap</Typography.Text>
					<BackTop>
						<div className={styles.backToTop} onClick={onBackToTopClicked}>
							<DoubleLeftOutlined
								style={{
									color: '#FFFFFF',
									fontSize: '2rem',
									fontWeight: '900'
								}}
							/>
						</div>
					</BackTop>
				</Footer>
			</Layout>
		</>
	);
};
export default observer(MainLayout);
